import { render, staticRenderFns } from "./ProviderCallback.vue?vue&type=template&id=85df01ea&"
import script from "./ProviderCallback.vue?vue&type=script&lang=js&"
export * from "./ProviderCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports